import { DrEntity } from './dr-entity';

export class Survivorship extends DrEntity {
    executionOrder: number;
    priority: number;
    query: string;
    constructor(value?: Partial<Survivorship>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}
